module.exports = __webpack_public_path__ + "static/media/pdf.5e67e667.png";